import useI18n from '@/hooks/useI18n'
import { useSiteSnapshot } from '@/features/site-control/useSiteControl'

const TradingHaltNotice = () => {
  const i18n = useI18n()
  const status = useSiteSnapshot()
  if (!status.tradingPaused) return null
  const body = status.message || i18n('trading_halt.body')

  return (
    <div
      role="status"
      className="rounded-lg border border-Neutral-3 bg-surface-2 p-4 text-Neutral-5"
    >
      <p className="text-base font-semibold">{i18n('trading_halt.title')}</p>
      <p className="mt-1 text-sm text-Neutral-4">{body}</p>
    </div>
  )
}

export default TradingHaltNotice
